var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:['sms-btn', _vm.time > 0 ? 'sending' : ''],attrs:{"disabled":_vm.time > 0,"loading":_vm.loading,"plain":""},on:{"click":function($event){return _vm.runHandle()}}},[_vm._v(_vm._s(_vm.smsText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }